import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ButtonModule } from '../button/button.module';
import { ProgressModule } from '../progress/progress.module';
import { NavigationModule } from '../navigation/navigation.module';
import { RouterModule } from '@angular/router';
import { UtilitiesModule } from '../utilities/utilities.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    ButtonModule,
    ProgressModule,
    NavigationModule,
    RouterModule,
    UtilitiesModule
  ]
})
export class FormCoreModule { }
